import Payslipcomp from '../components/payslip';
const Payslip = () => {
  return (
    <>   
    <Payslipcomp/>
    </>
  );
};

export default Payslip;
